// ./hooks/usePagination.js
import { useState } from "react";

export const usePagination = (
  initialState = { currentPage: 1, perPage: 50 }
) => {
  const [pagination, setPagination] = useState({
    ...initialState,
    total: 0,
  });

  const handlePageChange = (newPage) => {
    setPagination((prev) => {
      const calculatedTotalPages = Math.ceil(prev.total / prev.perPage);
      return {
        ...prev,
        currentPage: Math.max(1, Math.min(newPage, calculatedTotalPages)),
      };
    });
  };

  const handlePerPageChange = (newPerPage) => {
    setPagination((prev) => ({
      ...prev,
      perPage: newPerPage,
      currentPage: 1,
    }));
  };

  return {
    pagination,
    setPagination,
    handlePageChange,
    handlePerPageChange,
  };
};
